/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateCartRequestCart } from './CreateCartRequestCart';
import {
    CreateCartRequestCartFromJSON,
    CreateCartRequestCartFromJSONTyped,
    CreateCartRequestCartToJSON,
} from './CreateCartRequestCart';

/**
 * 
 * @export
 * @interface CreateCartRequest
 */
export interface CreateCartRequest {
    /**
     * 
     * @type {CreateCartRequestCart}
     * @memberof CreateCartRequest
     */
    cart?: CreateCartRequestCart;
}

/**
 * Check if a given object implements the CreateCartRequest interface.
 */
export function instanceOfCreateCartRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateCartRequestFromJSON(json: any): CreateCartRequest {
    return CreateCartRequestFromJSONTyped(json, false);
}

export function CreateCartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCartRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cart': !exists(json, 'cart') ? undefined : CreateCartRequestCartFromJSON(json['cart']),
    };
}

export function CreateCartRequestToJSON(value?: CreateCartRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cart': CreateCartRequestCartToJSON(value.cart),
    };
}

